// 2021 Topps Star Wars Signature Series — the first all-autograph Signature
// Series product (released February 17, 2021; 1 encased autograph per box,
// 1 card per pack, 20 boxes per case).
// Cards verified against the official Topps checklist PDF
// (CheckList_21SWSG_VERSION1.pdf); parallels cross-checked against Cardboard
// Connection and Beckett: base autographs are unnumbered encased cards with a
// Purple /99 -> Blue /50 -> Green /25 -> Orange /10 -> Black /5 -> Red 1/1
// ladder; dual and triple autographs have only the Red 1/1 parallel.
// The hobby box back's odds notation (*Sequentially Numbered: Dual Autograph
// 1:761, Triple Autograph 1:1,522, Dual/Triple Red Parallel 1:2,853) shows the
// base duals and triples ARE serial numbered, but no source publishes the run
// (Cardboard Connection, Beckett, and TCDB are all silent) — modeled with no
// serial slot rather than inventing one, matching the 2022 Mandalorian Chrome
// signed die-cut precedent. Purple /99 has no published box odds (the ladder
// odds start at Blue 1:6).
// The PDF's connector column (" as ", "voice of", ", puppeteer for",
// ", operator for") is dropped: name = signer, artist = character, matching
// 2023-signature-series.
// PDF-verbatim quirks kept on purpose:
// - DA-RD is printed "Daisy Ridley as Kylo Ren / Adam Driver as Dark Rey" and
//   DA-WM "Peter Mayhew as Lando Calrissian / Billy Dee Williams as Chewbacca"
//   — the characters are swapped on the official PDF (Cardboard Connection
//   lists them un-swapped). Kept verbatim per the PDF-is-final rule.
// - TA-EFS pairs Nika Futterman with Ahsoka Tano and Ashley Eckstein with
//   Asajj Ventress (the reverse of their actual roles) on BOTH the PDF and
//   Cardboard Connection.
// - "DEE Bradley Baker" capitalization is on the PDF.
// - Codes are assigned loosely: A-AH is Alden Ehrenreich (H = Han), A-WA is
//   Denis Lawson (Wedge Antilles), single-letter A-S = Stephen Stanton and
//   A-A = Annabelle Davis; Cards II dedupes against Cards I with extra letters
//   (A-CC2 Cavin Cornwall, A-RPC Ron Perlman, A-BBE Blair Bess, A-BMR Bobby
//   Moynihan, A-GCM Gina Carano, A-JTS John Tui, A-TBS Thomas Brodie-Sangster).

export const SETS = [
  {
    id: "autograph-cards-i", type: "auto", title: "AUTOGRAPH CARDS I — 98 CARDS",
    parallels: [
      {id:"purple",name:"Purple",print_run:99,color:"#b060ff"},
      {id:"blue",name:"Blue",print_run:50,color:"#4d9fff"},
      {id:"green",name:"Green",print_run:25,color:"#00e676"},
      {id:"orange",name:"Orange",print_run:10,color:"#ff9100"},
      {id:"black",name:"Black",print_run:5,color:"#a8a8b4"},
      {id:"red",name:"Red",print_run:1,color:"#ff5d5d"},
    ],
    cards: [
      {n:"A-AB", name:"Ahmed Best", artist:"Jar Jar Binks"},
      {n:"A-AB2", name:"Ahmed Best", artist:"Jar Jar Binks"},
      {n:"A-AB3", name:"Ahmed Best", artist:"Jar Jar Binks"},
      {n:"A-AD", name:"Adam Driver", artist:"Kylo Ren"},
      {n:"A-AD2", name:"Adam Driver", artist:"Kylo Ren"},
      {n:"A-AD3", name:"Adam Driver", artist:"Ben Solo"},
      {n:"A-AE", name:"Ashley Eckstein", artist:"Ahsoka Tano"},
      {n:"A-AE2", name:"Ashley Eckstein", artist:"Ahsoka Tano"},
      {n:"A-AE3", name:"Ashley Eckstein", artist:"Aleena"},
      {n:"A-AF", name:"Anthony Forrest", artist:"Fixer"},
      {n:"A-AF2", name:"Anthony Forrest", artist:"Sandtrooper"},
      {n:"A-AH", name:"Alden Ehrenreich", artist:"Han Solo"},
      {n:"A-AH2", name:"Alden Ehrenreich", artist:"Han Solo"},
      {n:"A-AS", name:"Andy Serkis", artist:"Supreme Leader Snoke"},
      {n:"A-AS2", name:"Andy Serkis", artist:"Supreme Leader Snoke"},
      {n:"A-BB", name:"Ben Burtt", artist:"Colonel Dyer"},
      {n:"A-BB2", name:"Ben Burtt", artist:"BD-1"},
      {n:"A-BL", name:"Billie Lourd", artist:"Kaydel Ko Connix"},
      {n:"A-BL2", name:"Billie Lourd", artist:"Kaydel Ko Connix"},
      {n:"A-BL3", name:"Billie Lourd", artist:"Kaydel Ko Connix"},
      {n:"A-BW", name:"Billy Dee Williams", artist:"Lando Calrissian"},
      {n:"A-BW2", name:"Billy Dee Williams", artist:"Lando Calrissian"},
      {n:"A-BW3", name:"Billy Dee Williams", artist:"Lando Calrissian"},
      {n:"A-CC", name:"Cavin Cornwall", artist:"Pemmin Brunce"},
      {n:"A-CF", name:"Carrie Fisher", artist:"Princess Leia Organa"},
      {n:"A-CF2", name:"Carrie Fisher", artist:"General Leia Organa"},
      {n:"A-DB", name:"DEE Bradley Baker", artist:"Commander Cody"},
      {n:"A-DB2", name:"DEE Bradley Baker", artist:"Kassius Konstantine"},
      {n:"A-DB3", name:"DEE Bradley Baker", artist:"Bossk"},
      {n:"A-DG", name:"Domhnall Gleeson", artist:"General Hux"},
      {n:"A-DG2", name:"Domhnall Gleeson", artist:"General Hux"},
      {n:"A-DG3", name:"Domhnall Gleeson", artist:"General Hux"},
      {n:"A-DL", name:"Daniel Logan", artist:"Boba Fett"},
      {n:"A-DL2", name:"Daniel Logan", artist:"Boba Fett"},
      {n:"A-DR", name:"Daisy Ridley", artist:"Rey"},
      {n:"A-DR2", name:"Daisy Ridley", artist:"Rey"},
      {n:"A-DR3", name:"Daisy Ridley", artist:"Dark Rey"},
      {n:"A-EW", name:"Ewan McGregor", artist:"Obi-Wan Kenobi"},
      {n:"A-EW2", name:"Ewan McGregor", artist:"Obi-Wan Kenobi"},
      {n:"A-EW3", name:"Ewan McGregor", artist:"Obi-Wan Kenobi"},
      {n:"A-FJ", name:"Felicity Jones", artist:"Jyn Erso"},
      {n:"A-FJ2", name:"Felicity Jones", artist:"Jyn Erso"},
      {n:"A-FJ3", name:"Felicity Jones", artist:"Jyn Erso"},
      {n:"A-FP", name:"Freddie Prinze Jr.", artist:"Kanan Jarrus"},
      {n:"A-FP2", name:"Freddie Prinze Jr.", artist:"Kanan Jarrus"},
      {n:"A-GC", name:"Gwendoline Christie", artist:"Captain Phasma"},
      {n:"A-GC2", name:"Gwendoline Christie", artist:"Captain Phasma"},
      {n:"A-GG", name:"Greg Grunberg", artist:"Snap Wexley"},
      {n:"A-GG2", name:"Greg Grunberg", artist:"Snap Wexley"},
      {n:"A-GO", name:"Genevieve O'Reilly", artist:"Mon Mothma"},
      {n:"A-HC", name:"Hayden Christensen", artist:"Anakin Skywalker"},
      {n:"A-HC2", name:"Hayden Christensen", artist:"Anakin Skywalker"},
      {n:"A-HC3", name:"Hayden Christensen", artist:"Darth Vader"},
      {n:"A-IM", name:"Ian McDiarmid", artist:"Senator Palpatine"},
      {n:"A-IM2", name:"Ian McDiarmid", artist:"Darth Sidious"},
      {n:"A-IM3", name:"Ian McDiarmid", artist:"Emperor Palpatine"},
      {n:"A-IW", name:"Ian Whyte", artist:"Moroff"},
      {n:"A-IW2", name:"Ian Whyte", artist:"Bollie Prindel"},
      {n:"A-JB", name:"John Boyega", artist:"Finn"},
      {n:"A-JB2", name:"John Boyega", artist:"Finn"},
      {n:"A-JB3", name:"John Boyega", artist:"Finn"},
      {n:"A-JS", name:"Joonas Suotamo", artist:"Chewbacca"},
      {n:"A-JS2", name:"Joonas Suotamo", artist:"Chewbacca"},
      {n:"A-JT", name:"James Arnold Taylor", artist:"Obi-Wan Kenobi"},
      {n:"A-JT2", name:"James Arnold Taylor", artist:"Plo Koon"},
      {n:"A-JT3", name:"James Arnold Taylor", artist:"Rako Hardeen"},
      {n:"A-KB", name:"Kenny Baker", artist:"R2-D2"},
      {n:"A-KB2", name:"Kenny Baker", artist:"R2-D2"},
      {n:"A-KB3", name:"Kenny Baker", artist:"R2-D2"},
      {n:"A-KT", name:"Kelly Marie Tran", artist:"Rose Tico"},
      {n:"A-KT2", name:"Kelly Marie Tran", artist:"Rose Tico"},
      {n:"A-PM", name:"Peter Mayhew", artist:"Chewbacca"},
      {n:"A-PM2", name:"Peter Mayhew", artist:"Chewbacca"},
      {n:"A-PM3", name:"Peter Mayhew", artist:"Chewbacca"},
      {n:"A-RD", name:"Robin Atkin Downes", artist:"Cham Syndulla"},
      {n:"A-RD2", name:"Robin Atkin Downes", artist:"Rush Clovis"},
      {n:"A-RP", name:"Ray Park", artist:"Darth Maul"},
      {n:"A-RP2", name:"Ray Park", artist:"Darth Maul"},
      {n:"A-RP3", name:"Ray Park", artist:"Maul"},
      {n:"A-S", name:"Stephen Stanton", artist:"Obi-Wan Kenobi"},
      {n:"A-S2", name:"Stephen Stanton", artist:"Mas Amedda"},
      {n:"A-S3", name:"Stephen Stanton", artist:"Moralo Eval"},
      {n:"A-SJ", name:"Samuel L. Jackson", artist:"Mace Windu"},
      {n:"A-SJ2", name:"Samuel L. Jackson", artist:"Mace Windu"},
      {n:"A-SJ3", name:"Samuel L. Jackson", artist:"Mace Windu"},
      {n:"A-SW", name:"Sam Witwer", artist:"Mortis Son"},
      {n:"A-SW2", name:"Sam Witwer", artist:"Maul"},
      {n:"A-SW3", name:"Sam Witwer", artist:"Emperor Palpatine"},
      {n:"A-TG", name:"Taylor Gray", artist:"Ezra Bridger"},
      {n:"A-TG2", name:"Taylor Gray", artist:"Ezra Bridger"},
      {n:"A-TM", name:"Temuera Morrison", artist:"Jango Fett"},
      {n:"A-TM2", name:"Temuera Morrison", artist:"Boba Fett"},
      {n:"A-TR", name:"Tim Rose", artist:"Admiral Ackbar"},
      {n:"A-TR2", name:"Tim Rose", artist:"Admiral Ackbar"},
      {n:"A-TR3", name:"Tim Rose", artist:"Admiral Ackbar"},
      {n:"A-WD", name:"Warwick Davis", artist:"Wicket W. Warrick"},
      {n:"A-WD2", name:"Warwick Davis", artist:"Weazel"},
      {n:"A-WD3", name:"Warwick Davis", artist:"Rukh"},
    ]
  },
  {
    id: "autograph-cards-ii", type: "auto", title: "AUTOGRAPH CARDS II — 65 CARDS",
    parallels: [
      {id:"purple",name:"Purple",print_run:99,color:"#b060ff"},
      {id:"blue",name:"Blue",print_run:50,color:"#4d9fff"},
      {id:"green",name:"Green",print_run:25,color:"#00e676"},
      {id:"orange",name:"Orange",print_run:10,color:"#ff9100"},
      {id:"black",name:"Black",print_run:5,color:"#a8a8b4"},
      {id:"red",name:"Red",print_run:1,color:"#ff5d5d"},
    ],
    cards: [
      {n:"A-A", name:"Annabelle Davis", artist:"Thromba"},
      {n:"A-A2", name:"Annabelle Davis", artist:"WG-22"},
      {n:"A-AG", name:"Anna Graves", artist:"Sugi"},
      {n:"A-AG2", name:"Anna Graves", artist:"Satine Kryze"},
      {n:"A-ASG", name:"Arti Shah", artist:"Gwellis Bagnoro"},
      {n:"A-BBE", name:"Blair Bess", artist:"Even Piell"},
      {n:"A-BM", name:"Ben Mendelsohn", artist:"Director Krennic"},
      {n:"A-BMR", name:"Bobby Moynihan", artist:"Orka"},
      {n:"A-CC2", name:"Cavin Cornwall", artist:"Sidon Ithano"},
      {n:"A-CDW", name:"Corey Dee Williams", artist:"Klaatu"},
      {n:"A-CH", name:"Clint Howard", artist:"Ralakili"},
      {n:"A-CM", name:"Cameron Monaghan", artist:"Cal Kestis"},
      {n:"A-CW", name:"Carl Weathers", artist:"Greef Karga"},
      {n:"A-DA", name:"Derek Arnold", artist:"Chancellor Villecham"},
      {n:"A-DA2", name:"Derek Arnold", artist:"Pao"},
      {n:"A-DA3", name:"Derek Arnold", artist:"Bor Gullet"},
      {n:"A-DC", name:"Dave Chapman", artist:"SE-2 \"Essie\" Worker Droid"},
      {n:"A-DC2", name:"Dave Chapman", artist:"BB-8"},
      {n:"A-DF", name:"Donald Faison", artist:"Hype Fazon"},
      {n:"A-DM", name:"Dominic Monaghan", artist:"Beaumont Kin"},
      {n:"A-DT", name:"Dee Tails", artist:"K-0HN"},
      {n:"A-DT2", name:"Dee Tails", artist:"Quay Tolsite"},
      {n:"A-DT3", name:"Dee Tails", artist:"Cratinus"},
      {n:"A-DW", name:"Debra Wilson", artist:"Cere Junda"},
      {n:"A-DY", name:"Donnie Yen", artist:"Chirrut Îmwe"},
      {n:"A-ES", name:"Emily Swallow", artist:"The Armorer"},
      {n:"A-FW", name:"Forest Whitaker", artist:"Saw Gerrera"},
      {n:"A-GCM", name:"Gina Carano", artist:"Cara Dune"},
      {n:"A-GE", name:"Giancarlo Esposito", artist:"Moff Gideon"},
      {n:"A-GP", name:"Greg Proops", artist:"Fode"},
      {n:"A-HD", name:"Harley Durst", artist:"Moloch"},
      {n:"A-HF", name:"Harrison Ford", artist:"Han Solo"},
      {n:"A-HF2", name:"Harrison Ford", artist:"Han Solo"},
      {n:"A-HF3", name:"Harrison Ford", artist:"Han Solo"},
      {n:"A-HS", name:"Horatio Sanz", artist:"Mythrol"},
      {n:"A-IR", name:"Ian Ruskin", artist:"Chancellor Valorum"},
      {n:"A-JK", name:"Jaime King", artist:"Aurra Sing"},
      {n:"A-JR", name:"Jerome Blake", artist:"Mas Amedda"},
      {n:"A-JR2", name:"Jerome Blake", artist:"Rune Haako"},
      {n:"A-JTS", name:"John Tui", artist:"Korso"},
      {n:"A-LT", name:"Lee Towersey", artist:"R2-D2"},
      {n:"A-MD", name:"Matt Doran", artist:"Elan Sleazebaggano"},
      {n:"A-MM", name:"Mads Mikkelsen", artist:"Galen Erso"},
      {n:"A-NF", name:"Nika Futterman", artist:"Asajj Ventress"},
      {n:"A-NF2", name:"Nika Futterman", artist:"Sy Snootles"},
      {n:"A-NF3", name:"Nika Futterman", artist:"TC-70"},
      {n:"A-NK", name:"Nick Kellington", artist:"Bistan"},
      {n:"A-NK2", name:"Nick Kellington", artist:"Klaud"},
      {n:"A-NN", name:"Nick Nolte", artist:"Kuiil"},
      {n:"A-PA", name:"Philip Anthony-Rodriguez", artist:"Fifth Brother"},
      {n:"A-PB", name:"Paul Bettany", artist:"Dryden Vos"},
      {n:"A-PP", name:"Pedro Pascal", artist:"The Mandalorian"},
      {n:"A-RA", name:"Riz Ahmed", artist:"Bodhi Rook"},
      {n:"A-RPC", name:"Ron Perlman", artist:"Gha Nachkt"},
      {n:"A-TBS", name:"Thomas Brodie-Sangster", artist:"Petty Officer Thanisson"},
      {n:"A-TD", name:"Tim Dry", artist:"J'Quille"},
      {n:"A-TF", name:"Tovah Feldshuh", artist:"Aunt Z"},
      {n:"A-TK", name:"Tom Kenny", artist:"Nute Gunray"},
      {n:"A-TK2", name:"Tom Kenny", artist:"Greedo"},
      {n:"A-TK3", name:"Tom Kenny", artist:"Silood"},
      {n:"A-TW", name:"Taika Waititi", artist:"IG-11"},
      {n:"A-WA", name:"Denis Lawson", artist:"Wedge Antilles"},
      {n:"A-WA2", name:"Denis Lawson", artist:"Wedge Antilles"},
      {n:"A-WA3", name:"Denis Lawson", artist:"Wedge Antilles"},
      {n:"A-WH", name:"Werner Herzog", artist:"The Client"},
    ]
  },
  {
    id: "dual-autographs", type: "auto", title: "DUAL AUTOGRAPHS — 8 CARDS",
    parallels: [
      {id:"red",name:"Red",print_run:1,color:"#ff5d5d"},
    ],
    cards: [
      {n:"DA-BC", name:"Gwendoline Christie / John Boyega", artist:"Captain Phasma / Finn"},
      {n:"DA-CM", name:"Ian McDiarmid / Hayden Christensen", artist:"Emperor Palpatine / Darth Vader"},
      {n:"DA-EB", name:"Alden Ehrenreich / Paul Bettany", artist:"Han Solo / Dryden Vos"},
      {n:"DA-JM", name:"Ben Mendelsohn / Felicity Jones", artist:"Director Krennic / Jyn Erso"},
      {n:"DA-LE", name:"Ashley Eckstein / Matt Lanter", artist:"Ahsoka Tano / Anakin Skywalker"},
      {n:"DA-PE", name:"Giancarlo Esposito / Pedro Pascal", artist:"Moff Gideon / The Mandalorian"},
      {n:"DA-RD", name:"Daisy Ridley / Adam Driver", artist:"Kylo Ren / Dark Rey"},
      {n:"DA-WM", name:"Peter Mayhew / Billy Dee Williams", artist:"Lando Calrissian / Chewbacca"},
    ]
  },
  {
    id: "triple-autographs", type: "auto", title: "TRIPLE AUTOGRAPHS — 8 CARDS",
    parallels: [
      {id:"red",name:"Red",print_run:1,color:"#ff5d5d"},
    ],
    cards: [
      {n:"TA-DCG", name:"Adam Driver / Gwendoline Christie / Domhnall Gleeson", artist:"Kylo Ren / Captain Phasma / General Hux"},
      {n:"TA-EFS", name:"Nika Futterman / Ashley Eckstein / Meredith Salenger", artist:"Ahsoka Tano / Asajj Ventress / Barriss Offee"},
      {n:"TA-ESK", name:"Alden Ehrenreich / Joonas Suotamo / Erin Kellyman", artist:"Han Solo / Chewbacca / Enfys Nest"},
      {n:"TA-JWA", name:"Felicity Jones / Forest Whitaker / Riz Ahmed", artist:"Jyn Erso / Saw Gerrera / Bodhi Rook"},
      {n:"TA-PGM", name:"Freddie Prinze Jr. / Taylor Gray / Vanessa Marshall", artist:"Kanan Jarrus / Ezra Bridger / Hera Syndulla"},
      {n:"TA-PWN", name:"Pedro Pascal / Taika Waititi / Nick Nolte", artist:"The Mandalorian / IG-11 / Kuiil"},
      {n:"TA-RDB", name:"Daisy Ridley / Adam Driver / John Boyega", artist:"Rey / Kylo Ren / Finn"},
      {n:"TA-RTL", name:"Daisy Ridley / Kelly Marie Tran / Billie Lourd", artist:"Rey / Rose Tico / Kaydel Ko Connix"},
    ]
  },
];
